import { create } from "zustand"

import { UserSelectFilterType } from "../../../types"

interface FamilyUserSelectStore {
  selectedUserId: number | null
  selectedFilterType: UserSelectFilterType
  setSelectedUserId: (userId: number | null) => void
}

const useFamilyUserSelectStore = create<FamilyUserSelectStore>((set) => ({
  selectedUserId: null,
  selectedFilterType: UserSelectFilterType.USER,
  setSelectedUserId: (userId) => set({ selectedUserId: userId }),
}))

export default useFamilyUserSelectStore
